import { ComponentProps, memo } from 'react'

import { Text } from '@cash-me/react-components'

import * as S from './styles'

type Props = Pick<ComponentProps<typeof Text>, 'children' | 'as' | 'size' | 'weight' | 'color' | 'uppercase'> & {
  className?: string
  barColor?: string
}

export const SectionLabel = memo(
  ({ children, as, size = 'caption', weight = 'medium', color, uppercase, className, barColor }: Props) => (
    <S.SectionLabel className={className}>
      <S.Bar aria-hidden $barColor={barColor} />
      <Text as={as} size={size} weight={weight} color={color} uppercase={uppercase}>
        {children}
      </Text>
    </S.SectionLabel>
  )
)

SectionLabel.displayName = 'SectionLabel'
